import React from 'react';
import { useNavigate } from 'react-router-dom';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import './ProgramDetail.css';

const EldersScheme = () => {
    useScrollAnimation();
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate('/programs/food');
    };

    return (
        <div className="program-detail-page">
            <div className="program-hero">
                <div className="container">
                    <button onClick={handleBackClick} className="back-link">
                        <i className="fas fa-arrow-left"></i> Back to Food Program
                    </button>
                    <div className="program-hero-content">
                        <div className="program-icon-hero">
                            <i className="fas fa-hands-holding-heart"></i> 
                        </div>
                        <h1>Engal Thatha Engal Patti Annadhana Scheme</h1>
                        <p className="program-tagline">Serving our elders with love, dignity, and respect</p>
                    </div>
                </div>
            </div>

            <div className="program-content">
                <div className="container">
                    <section className="program-section scroll-animate">
                        <h2>About the Scheme</h2>
                        <p>Engal Thatha Engal Patti (Our Grandfathers Our Grandmothers) Annadhana Scheme is our dedicated program to serve nutritious meals to elderly members of our community. We believe our elders deserve care, respect, and the assurance that they will never go hungry.</p>
                        <p>This program focuses on providing not just food, but also companionship and a sense of community. We serve fresh, hot meals prepared with love and attention to nutritional requirements of senior citizens.</p>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Key Achievements</h2>
                        <div className="achievements-grid">
                            <div className="achievement-card">
                                <div className="achievement-number">300+</div>
                                <div className="achievement-label">Elders Served</div>
                                <p>Daily beneficiaries of the program</p>
                            </div>
                            <div className="achievement-card">
                                <div className="achievement-number">2</div>
                                <div className="achievement-label">Meals Daily</div>
                                <p>Lunch and Dinner provided</p>
                            </div>
                            <div className="achievement-card">
                                <div className="achievement-number">365</div>
                                <div className="achievement-label">Days a Year</div>
                                <p>Continuous service without breaks</p>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>What We Offer</h2>
                        <div className="features-list">
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Nutritious Meals</h3>
                                    <p>Balanced diet designed for elderly nutritional needs</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Daily Lunch & Dinner</h3>
                                    <p>Two hot meals served every single day</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Dignified Service</h3>
                                    <p>Meals served with utmost respect and care</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Community Dining</h3>
                                    <p>Shared meals fostering social connection</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Fresh Ingredients</h3>
                                    <p>Daily preparation with quality ingredients</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Special Occasions</h3>
                                    <p>Festival meals and birthday celebrations</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Daily Schedule</h2>
                        <div className="activities-timeline">
                            <div className="activity">
                                <div className="activity-day">Morning</div>
                                <div className="activity-content">
                                    <h3>Meal Preparation</h3>
                                    <p>Fresh ingredients sourced and cooking begins with care</p>
                                </div>
                            </div>
                            <div className="activity">
                                <div className="activity-day">12:00 PM</div>
                                <div className="activity-content">
                                    <h3>Lunch Service</h3>
                                    <p>Hot, nutritious lunch served to 300+ elders</p>
                                </div>
                            </div>
                            <div className="activity">
                                <div className="activity-day">7:00 PM</div>
                                <div className="activity-content">
                                    <h3>Dinner Service</h3>
                                    <p>Evening meal provided with love and respect</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Menu Highlights</h2>
                        <div className="menu-grid">
                            <div className="menu-item">
                                <h3>Traditional South Indian</h3>
                                <p>Rice, Sambar, Rasam, Vegetables, Curd</p>
                            </div>
                            <div className="menu-item">
                                <h3>Variety Rice</h3>
                                <p>Tamarind rice, Lemon rice, Curd rice</p>
                            </div>
                            <div className="menu-item">
                                <h3>Special Days</h3>
                                <p>Biryani, Pongal, Pulao on occasions</p>
                            </div>
                            <div className="menu-item">
                                <h3>Festival Specials</h3>
                                <p>Traditional festival foods and sweets</p>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Program Impact</h2>
                        <div className="impact-stats">
                            <div className="impact-item">
                                <i className="fas fa-heart"></i>
                                <h3>Health Improvement</h3>
                                <p>Better nutrition and health outcomes for elderly</p>
                            </div>
                            <div className="impact-item">
                                <i className="fas fa-smile"></i>
                                <h3>Food Security</h3>
                                <p>Guaranteed meals bringing peace of mind</p>
                            </div>
                            <div className="impact-item">
                                <i className="fas fa-users"></i>
                                <h3>Social Connection</h3>
                                <p>Reducing isolation through community dining</p>
                            </div>
                        </div>
                    </section>

                    <section className="program-cta scroll-animate">
                        <h2>Support Engal Thatha Engal Patti Scheme</h2>
                        <p>Your donation helps us serve more elders and ensure no senior goes hungry</p>
                        <div className="cta-buttons">
                            <button onClick={() => navigate('/donate')} className="btn btn-primary btn-large">Donate Now</button>
                            <button onClick={() => navigate('/contact')} className="btn btn-secondary btn-large">Volunteer with Us</button>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default EldersScheme;
